import type z from "zod";

import { zSchema } from "../../../../entity";

import { zWithLanguage } from "~/shared/zod";

const zIn = zSchema
  .omit({
    id: true,
  })
  .merge(zWithLanguage);
type In = z.infer<typeof zIn>;

export { zIn };
export type { In };
